import { render, staticRenderFns } from "./Evaluate.vue?vue&type=template&id=67bdbb6e&scoped=true"
import script from "./Evaluate.vue?vue&type=script&lang=js"
export * from "./Evaluate.vue?vue&type=script&lang=js"
import style0 from "./Evaluate.vue?vue&type=style&index=0&id=67bdbb6e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67bdbb6e",
  null
  
)

export default component.exports